var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListIconOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.625C16.7635 20.625 20.625 16.7635 20.625 12C20.625 7.23654 16.7635 3.375 12 3.375C7.23654 3.375 3.375 7.23654 3.375 12C3.375 16.7635 7.23654 20.625 12 20.625Z",
    fill: "#FF7714"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M11.9688 5.23724C12.9351 5.23724 13.7215 4.50337 13.8235 3.56437C13.2257 3.43349 12.6059 3.36224 11.9688 3.36224C7.20512 3.36224 3.34375 7.22362 3.34375 11.9872C3.34375 12.6244 3.415 13.2442 3.54588 13.842C4.48525 13.74 5.21875 12.9536 5.21875 11.9872C5.21875 8.26537 8.24725 5.23724 11.9688 5.23724Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M20.3948 10.1329C19.4554 10.2349 18.7219 11.0212 18.7219 11.9876C18.7219 15.7095 15.6938 18.7376 11.9719 18.7376C11.0056 18.7376 10.2192 19.4715 10.1172 20.4105C10.7149 20.5414 11.3348 20.6126 11.9719 20.6126C16.7356 20.6126 20.5969 16.7512 20.5969 11.9876C20.5969 11.3505 20.5261 10.7302 20.3948 10.1329Z",
    fill: "#212121"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.61328 8.77241C6.31753 7.38528 7.46278 6.25804 8.86303 5.57666",
    stroke: "white",
    strokeWidth: 1.125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12 24C15.935 24 19.125 23.4963 19.125 22.875C19.125 22.2537 15.935 21.75 12 21.75C8.06497 21.75 4.875 22.2537 4.875 22.875C4.875 23.4963 8.06497 24 12 24Z",
    fill: "#212121"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8749 15.75C10.6829 15.75 10.4913 15.6768 10.3447 15.5302L7.71966 12.9052C7.42678 12.6123 7.42678 12.1376 7.71966 11.8447C8.01253 11.5518 8.48728 11.5518 8.78016 11.8447L10.8749 13.9391L15.5947 9.21972C15.8875 8.92684 16.3623 8.92684 16.6552 9.21972C16.948 9.51259 16.948 9.98734 16.6552 10.2802L11.4052 15.5302C11.2585 15.6768 11.0669 15.75 10.8749 15.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIconOrange);
export default __webpack_public_path__ + "static/media/ListIconOrange.1d53ce3c6ca15ecccff9b1996598cd4c.svg";
export { ForwardRef as ReactComponent };